export const getInitialState = (): any => ({
  summaryData: {},
  summaryStatus: 0
});
